import React, { useContext, useEffect, useState } from "react";
import "./SituacaoFiscalAnalitico.scss";
import useLoading from "@hooks/useLoading";
import GlobalContext from "@context/GlobalContext";
import { useNavigate } from "react-router-dom";
import usePermissoes from "@hooks/usePermissoes";
import Grid from "@components/grid/Grid";
import mappingColumn from "@components/grid/mappingColumn";
import EndPointServices from "@services/ApiServices";
import Modal from "@components/modal/Modal";

const SituacaoFiscalAnalitico = () => {
  //State Padrões
  const [setLoading] = useLoading();
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const { handlePermissoes } = usePermissoes();

  //Situacao Fiscal Analitico
  const [analitico, setAnalitico] = useState([]);
  const [loadingGrid, setLoadingGrid] = useState(false);

  //Modal de Vizualização
  const [showModal, setShowModal] = useState(false);
  const [base64, setBase64] = useState(null);

  useEffect(() => {
    handleConsultar_SituacaoFiscalAnalitico();
  }, []);

  async function handleConsultar_SituacaoFiscalAnalitico() {
    setLoadingGrid(true);

    console.log("state", state);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      tipo: state.situacaofiscal?.tipo,
      ID_Empresa: state.situacaofiscal?.retornoPesquisa?.[0]?.valor?.ID,
    };

    try {
      var retornoapi =
        await EndPointServices.ECAC_SituacaoFiscal_ConsultaAnalitico(data);
      if (retornoapi.Success) {
        setAnalitico(retornoapi?.BaseReturn?.LstClasse);
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoadingGrid(false);
  }

  return (
    <div className="situacaofiscalanalitico container-fluid">
      <Grid
        dadosGrid={analitico}
        columns={mappingColumn.getECAC_SituacaoFiscalAnalitica(
          analitico,
          handlePermissoes,
          setShowModal,
          setBase64,
        )}
        {...(analitico.length > 0 && {
          pageVisible: true,
        })}
        useMemo={!loadingGrid}
        Loading={loadingGrid}
        pagingStaticSize="5"
      />
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Visualizador de PDF"
        width="90vw"
        height="90vh"
      >
        <div style={{ height: "80vh", width: "100%" }}>
          <iframe
            title="Visualizador de PDF"
            src={`data:application/pdf;base64,${base64}`}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default SituacaoFiscalAnalitico;
